var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenderAmbiguous = function SvgGenderAmbiguous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191F2E",
    fillRule: "evenodd",
    d: "M17.25 1.5a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V2.56l-5.174 5.175a6.001 6.001 0 0 1-4.576 8.719V19.5H15a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0V21H9a.75.75 0 0 1 0-1.5h2.25v-3.046a6.001 6.001 0 1 1 5.207-9.971L21.439 1.5zm-1.495 6.519a4.5 4.5 0 1 0-7.509 4.963 4.5 4.5 0 0 0 7.509-4.963",
    clipRule: "evenodd"
  })));
};
export default SvgGenderAmbiguous;